import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { DepartmentApiService } from '@shared/services';
import { DEPARTMENT_BY_PARENT_TREE_SELECT_CONFIG } from '@shared/components/generic-treeselect/generic-treeselect.configs';

export const changeTeamFormConfig = (): FormConfig => {
  const departmentApiService = inject(DepartmentApiService);

  return {
    fields: [
      {
        key: 'employeePositionId', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'rootDepartmentId', label: 'Root Department ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'position', label: 'Vị trí', labelPosition: 'inline', width: 'full',
        type: 'static', value: (data: any) => data.position?.name || ''
      },
      {
        key: 'departmentId', label: 'Team mới', required: true, width: 'half',
        type: 'treeselect', config: { ...DEPARTMENT_BY_PARENT_TREE_SELECT_CONFIG, service: departmentApiService },
        dependsOn: 'rootDepartmentId',
        customErrorMessage: 'Vui lòng chọn team mới',
        disabled: (editMode: boolean, formValue: any) => !formValue?.rootDepartmentId,
      },
      {
        key: 'fromDate', label: 'Ngày hiệu lực', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn ngày hiệu lực',
        customErrorMessage: 'Vui lòng chọn ngày hiệu lực'
      }
    ]
  };
};
